import { styled } from '@/stitches.config';
import { Box } from '@base-app';

export const StyledListItem = styled('li', {
  maxWidth: '600px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const TeamsListMobileStyled = styled(Box, {
  display: 'block',
  px: '$4',
  '@sm': {
    display: 'none',
  },
  '& ul': {
    listStyleType: 'none',
    padding: '$0',
    margin: '$0',
  },
});

export const TeamsListItemStyled = styled('li', {
  borderBottom: '$borderWidths$1 solid $colors$coolGray200',
  py: '$5',
  textAlign: 'left',
  '&:last-child': {
    borderBottom: '$0',
  },
});
